import { SxProps, Theme } from "@mui/material";

export const mainLayoutSx: SxProps<Theme> = {
  display: "flex",
  height: "100vh",
  backgroundColor: "#F7F7F7",
};

export const contentWrapperSx: SxProps<Theme> = {
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
};

export const outletBoxSx: SxProps<Theme> = {
  flexGrow: 1,
  padding: 1,
  overflow: "auto",
  backgroundColor: "#F7F7F7",
};
